import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest } from "redux-saga/effects";
import * as api from "./GivingsAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";


function* getGivingsListRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
        const payload = action.payload.apiPayloadRequest;
        const response = yield call(api.getGivingsList, payload);
        action.payload.callback(response);
    } catch (err) {
        if (err?.response) {
                    } else {
                    }
    } finally {
        yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
}

function* getUserProfileRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
        const payload = action.payload.apiPayloadRequest;
        const response = yield call(api.getUserProfile, payload);
        action.payload.callback(response);
    } catch (err) {
        if (err?.response) {
                    } else {
                    }
    } finally {
        yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
}

function* getUserTransactionsRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
        const payload = action.payload.apiPayloadRequest;
        const response = yield call(api.getUserTransactions, payload);
        action.payload.callback(response);
    } catch (err) {
        if (err?.response) {
                    } else {
                    }
    } finally {
        yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
}

function* postRefundRequestSaga(action) {
    yield put(actionUpdateGlobalLoaderSagaAction(true));
    try {
        const payload = action.payload.apiPayloadRequest;
        const response = yield call(api.postRefund, payload);
        action.payload.callback(response);
    } catch (err) {
        if (err?.response) {
                    } else {
                    }
    } finally {
        yield put(actionUpdateGlobalLoaderSagaAction(false));
    }
}

export default function* GivingsWatcherSaga() {
    yield takeLatest(
        actionTypes.GET_GIVINGS_LIST_REQUEST,
        getGivingsListRequestSaga
    );

    yield takeLatest(
        actionTypes.GET_USER_PROFILE_REQUEST,
        getUserProfileRequestSaga
    );

    yield takeLatest(
        actionTypes.GET_USER_TRANSACTIONS_REQEST,
        getUserTransactionsRequestSaga
    );

    yield takeLatest(
        actionTypes.POST_REFUND_REQUEST,
        postRefundRequestSaga
    );

}